<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <vs-button
        @click="$router.push({name: 'care-create'})"
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        class="mb-4 self-end"
        size="medium"
        v-if="isUserCanCreate"
      >Tambah Pengaduan</vs-button>
      <vs-alert title="Informasi" class="my-5">
        Berikut ini merupakan menu Verifikasi Pengaduan MPP Care. Silahkan tindaklajuti pengaduan dari masyarakat yang melalui sistem
        MPP Care.
      </vs-alert>
      <div class="w-full">
        <global-new-wrapper
          :loading="loading"
          :loadingType="'OneLine'"
          :loadingList="5"
          :empty="complaints.data.length == 0"
          :error="error"
        >
          <global-table
            @reloadData="handleOnReloadData($event)"
            :currentPage="complaints.current_page"
            :totalPage="complaints.last_page"
          >
            <template #thead>
              <global-th width="20px">No.</global-th>
              <global-th>Kode Registrasi</global-th>
              <global-th>Pelapor</global-th>
              <global-th>Judul</global-th>
              <global-th>Status</global-th>
              <global-th>Action</global-th>
            </template>
            <template #tbody>
              <global-tr v-for="(item, index) in complaints.data" :key="index">
                <global-td>{{index+1}}</global-td>
                <global-td>
                  {{item.registration_code}} <br>
                  <small>{{item.created_at}}</small>
                </global-td>
                <global-td>{{item.name}}</global-td>
                <global-td>{{item.title.substring(0, 30)}} ...</global-td>
                <global-td>
                  <ComplaintStatusChip :status="item.status"/>
                </global-td>
                <global-td>
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click="$router.push({name: 'care-detail', params: {id: item.id}})"
                    >Verifikasi
                  </vs-button>
                </global-td>
              </global-tr>
            </template>
          </global-table>
        </global-new-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import ComplaintStatusChip from "@/components/chip/ComplaintStatusChip";
import { CARE_OPERATOR_ROLE} from "@/const/complaint";

export default {
  components: {
    "v-select": vSelect,
    Datepicker,
    ComplaintStatusChip
  },
  data() {
    return {
      loading: true,
      error: false,
      complaints: {
        data: []
      },
      pagination: {
        currentPage: 1,
        perPage: 10
      }
    };
  },
  computed:{
    isUserCanCreate(){
      return this.$store.state.AppActiveUser.role == CARE_OPERATOR_ROLE;
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      let data = {
        page: this.pagination.currentPage
      };

      this.$http
      .get("/app/secure/complaint-verification/data", {params : {...data}})
      .then(response => {
        this.complaints = response.data.data.complaints;
        this.loading = false;
      })
      .catch(e => {
        this.parseError(e);
      })
      .finally(() => {
        this.$vs.loading.close();
      });
    },
    resetFilterDate(){
      this.startDate = "";
      this.endDate = "";
      this.getData();
    },
    handleOnReloadData(currentPage) {
      this.pagination.currentPage = currentPage;
      this.getData();
    },
  },
};
</script>
